import React, { useEffect, useRef, useState } from "react";
import {
    StartStreamTranscriptionCommand,
    TranscribeStreamingClient,
} from "@aws-sdk/client-transcribe-streaming";
import MicrophoneStream from "microphone-stream";
import { Buffer } from "buffer";
import {
    DropdownMenu,
    DropdownToggle,
    UncontrolledButtonDropdown,
} from "reactstrap";
import startRecorder from "../../../../assets/icons/record/startRecorder.svg";
import stopRecorder from "../../../../assets/icons/record/stopRecorder.svg";
import { handleStopRecording } from "../../../../redux/layout";
import { useDispatch, useSelector } from "react-redux";

const SAMPLE_RATE = 44100;
const AWS_REGION = "us-east-1";
const AWS_ACCESS_KEY_ID = process.env.REACT_APP_API_AWS_ACCESS_KEY_ID;
const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_API_AWS_SECRET_ACCESS_KEY;

function SpechToText({
    isRecording,
    isSubscription,
    setOriginalText,
    originalText,
    text,
    setText,
    setTranscribe,
    setIsRecording,
    setIsRecorder,
    setIsSummeryTab,
    setIsSummerized,
    setIsCancelRecording,
    isCancelRecording,
    setEditorState,
    setNoteType,
    noteType,
    onlytext,
}) {
    const microphoneStream = useRef(null);
    const mediaStream = useRef(null);
    const transcribeClient = useRef(null);
    const audioStream = useRef(null);
    const dispatch = useDispatch();
    const role = useSelector((state) => state.layout.role);
    const createTranscribeClient = () => {
        transcribeClient.current = new TranscribeStreamingClient({
            region: AWS_REGION,
            credentials: {
                accessKeyId: AWS_ACCESS_KEY_ID,
                secretAccessKey: AWS_SECRET_ACCESS_KEY,
            },
        });
    };

    const createMicrophoneStream = async () => {
        mediaStream.current = await window.navigator.mediaDevices.getUserMedia({
            video: false,
            audio: {
                sampleRate: SAMPLE_RATE,
            },
        });

        microphoneStream.current = new MicrophoneStream();
        microphoneStream.current.setStream(mediaStream.current); // Using the same media stream for microphone
        startStreaming();
    };

    const encodePCMChunk = (chunk) => {
        const input = MicrophoneStream.toRaw(chunk);
        let offset = 0;
        const buffer = new ArrayBuffer(input.length * 2);
        const view = new DataView(buffer);
        for (let i = 0; i < input.length; i++, offset += 2) {
            let s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        }
        return Buffer.from(buffer);
    };

    const getAudioStream = async function* () {
        for await (const chunk of microphoneStream.current) {
            if (chunk.length <= SAMPLE_RATE) {
                yield {
                    AudioEvent: {
                        AudioChunk: encodePCMChunk(chunk),
                    },
                };
            }
        }
    };

    const startStreaming = async () => {
        document.title = "Recording...";
        const command = new StartStreamTranscriptionCommand({
            LanguageCode: "en-US",
            MediaEncoding: "pcm",
            MediaSampleRateHertz: SAMPLE_RATE,
            AudioStream: getAudioStream(),
        });
        const data = await transcribeClient.current.send(command);

        for await (const event of data.TranscriptResultStream) {
            const results = event.TranscriptEvent.Transcript.Results;
            if (results.length && !results[0]?.IsPartial) {
                const newTranscript = results[0].Alternatives[0].Transcript;
                setText(`<span>${newTranscript}</span>`);
            }
        }
        setIsRecorder(true);
    };

    const stopRecording = () => {
        if (
            (noteType == "upload" ||
                noteType == "mixed" ||
                noteType == "regular") &&
            onlytext != ""
        ) {
            setNoteType("mixed");
        } else {
            setNoteType("transcription");
        }
        dispatch(handleStopRecording(false));
        setTranscribe(true);
        if (microphoneStream.current) {
            microphoneStream.current.stop();
            microphoneStream.current.destroy();
            microphoneStream.current = undefined;
        }
        document.title = "Account";
        setTranscribe(false);
        setIsRecording(false);
        setIsSummeryTab(false);
        setIsSummerized(false);
        setText("");
    };

    const startRecording = async () => {
        dispatch(handleStopRecording(true));
        createTranscribeClient();
        createMicrophoneStream();
        setIsRecording(true);
        setTranscribe(true);
        setIsSummeryTab(false);
    };

    useEffect(() => {
        if (originalText == null) {
            setOriginalText(text);
        } else {
            setOriginalText(originalText + " " + text);
        }
    }, [text]);

    useEffect(() => {
        if (isCancelRecording == true) {
            stopRecording();
            setOriginalText("");
            setEditorState("");
            setIsCancelRecording(false);
        }
    }, [isCancelRecording]);

    return (
        <div className="App">
            {isSubscription || role == "instructor" ? (
                <div className="record">
                    {isRecording ? (
                        <img
                            src={stopRecorder}
                            alt="stopRecorder"
                            onClick={stopRecording}
                        />
                    ) : (
                        <img
                            src={startRecorder}
                            alt="startRecorder"
                            onClick={startRecording}
                        />
                    )}
                </div>
            ) : (
                <UncontrolledButtonDropdown>
                    <DropdownToggle id="voiceIcone">
                        <div className="record">
                            {isRecording ? (
                                <img src={stopRecorder} alt="stopRecorder" />
                            ) : (
                                <img src={startRecorder} alt="startRecorder" />
                            )}
                        </div>
                    </DropdownToggle>
                    <DropdownMenu tag="div" end>
                        <div className="msgPremium">
                            You need to have a premium subscription to use the
                            transcription function.
                        </div>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            )}
        </div>
    );
}

export default SpechToText;
